import { generatePath, Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Flex, Table, Typography } from "antd"
import { ColumnsType } from "antd/es/table"

import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { paths } from "@src/app/paths"
import { MassPayoutsCardCollection } from "@src/pages/massPayouts/cards/classes/MassPayoutsCardCollection"
import { CardMassPayoutShort } from "@src/shared/api/generated"
import { WithCollection } from "@src/shared/classes/Collection/types"
import { TableFilters } from "@src/shared/componemts/TableFilter"
import { dateTimeFormat } from "@src/shared/date"
import css from "./index.module.css"

type Props = WithCollection<MassPayoutsCardCollection>
export const MassPayoutCardsTable = observer(({ collection }: Props) => {
  const columns: ColumnsType<CardMassPayoutShort> = [
    {
      dataIndex: "id",
      render: (_, { id }) => {
        return (
          <Link
            id="GENERATED_ID_MASSPAYOUTSTABLE_LINK_VOID_1"
            to={generatePath(paths.payoutsCard, { id })}
          >
            {<IdItem id={id} />}
          </Link>
        )
      },
      title: "ID",
    },
    {
      dataIndex: "created_at",
      render: (_, { created_at }) => dateTimeFormat(created_at),
      title: "Date and Time",
    },
    {
      dataIndex: "data",
      render: (_, { created_at }) => dateTimeFormat(created_at),
      title: "Date and Time",
    },
    {
      dataIndex: "external_id",
      title: "External ID",
    },
    {
      dataIndex: "status",
      title: "Status",
    },
    {
      dataIndex: "stats",
      render: (_, { stats }) => {
        return <span>{`${stats?.sent} / ${stats?.total}`}</span>
      },
      title: "Transactions sent",
    },
    {
      dataIndex: "stats",
      render: (_, { stats }) => {
        return <span>{stats?.failed}</span>
      },
      title: "Send errors",
    },
  ]

  return (
    <Flex className={css.tableWrap} gap={24} vertical>
      <TableFilters {...collection.filter.props} />

      <Table
        columns={columns}
        dataSource={collection.items}
        loading={collection.isLoading}
        pagination={collection.pagination}
      ></Table>
    </Flex>
  )
})
